import React from 'react';
import { withCookies } from 'react-cookie';
import cookie from 'react-cookies';
import { FolderOpenFilled } from '@ant-design/icons';
import { Spin } from 'antd';
import { SearchBar, List, Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';

import "./index.css";
import styles from "./formlist.module.css";
import { _listForm, _saveCommonForm, _loginByCode } from "../../server";

const Item = List.Item;
const Brief = Item.Brief;

class FormListPage extends React.Component {

    groupColor;

    constructor(props) {
        super(props)

        this.state = { forms: [], showFormInfoView: false, currentForm: {}, originList: [], isLoading: true, groupId: "", code: "", };
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        if (this.props.location.query && this.props.location.query.group) {
            this.state.groupId = this.props.location.query.group.id;
            this.groupColor = this.props.location.query.group.groupColor;
        }
        if (!this.state.groupId) {
            this.state.groupId = window.sessionStorage.getItem("groupId");
            window.sessionStorage.setItem("groupId", "");
        }

        if (window.location.search) {
            let strSearch = window.location.search;
            let params = strSearch.substring(1, strSearch.length).split('&');
            if (params) {
                params.map((item, i) => item.split('=')[0] === 'code' ? this.state.code = item.split('=')[1] : "");
            }
        }

        this.listForm();
    }

    async listForm() {
        const res = await _listForm(this.sid, this.state.groupId);
        if (res.code === 0) {
            this.setState({ forms: res.data.list, originList: [].concat(res.data.list) });
            this.setState({ isLoading: false });
        } else if (res.code === 9999) {
            cookie.remove(process.env.TOKEN_KEY, { path: '/' });
            if (this.state.code) {
                this.loginByCode();
            } else {
                this.props.history.push("/");
                this.setState({ isLoading: false });
            }
        }
    }

    async loginByCode() {
        const res = await _loginByCode(this.state.code);
        if (res.code === 0) {
            const { cookies } = this.props;
            cookies.set(process.env.TOKEN_KEY, res.data.sid, { path: '/' });
            this.sid = res.data.sid;
            this.listForm();
        } else {
            this.props.history.push("/");
        }
    }

    async saveCommonForm(isCommon) {
        const res = await _saveCommonForm(this.sid, this.state.currentForm.definitionId, isCommon);
        if (res.code === 0) {
            this.state.currentForm.isCommon = isCommon;

            this.state.forms.map(item => {
                if (this.state.currentForm.definitionId === item.definitionId) {
                    item.isCommon = isCommon;
                }
            });
            this.state.originList.map(item => {
                if (this.state.currentForm.definitionId === item.definitionId) {
                    item.isCommon = isCommon;
                }
            });

            this.setState({ forms: this.state.forms, originList: this.state.originList });

            if (isCommon === 1) {
                Toast.info('收藏为常用表单成功', 1);
            } else {
                Toast.info('取消常用表单成功', 1);
            }
        }
    }

    showFormInfo(e, item) {
        this.setState({ currentForm: item });
        this.setState({ showFormInfoView: true });
    }

    closeFormInfo = () => {
        this.setState({ showFormInfoView: false });
    }

    gotoFormMain() {
        window.sessionStorage.setItem("groupId", this.state.groupId);
        this.props.history.push({ pathname: '/formmain', query: { formId: this.state.currentForm.formId } });
    }

    render() {
        const view_listForm = this.state.forms.map((item, index) =>
            <Item key={index} style={{ padding: 10 }} arrow="horizontal" onClick={(e) => this.showFormInfo(e, item)}
                thumb={<FolderOpenFilled
                    style={{ fontSize: 25, color: 'white', padding: 6, borderRadius: 5, backgroundColor: item.groupColor }} />}
            >{item.formName}
            </Item>
        );

        return (
            <div className="wrap" style={{ overflowY: 'auto' }}>
                <SearchBar placeholder="搜索关键词" maxLength={20}
                    className={styles.my_searchBar}
                    onChange={(value) => {
                        if (value) {
                            let tmpArray = [];
                            this.state.originList.map((item) => {
                                if (item.formName.toUpperCase().indexOf(value.toUpperCase()) >= 0) {
                                    tmpArray.splice(tmpArray.length, 0, item);
                                }
                            })
                            this.setState({ forms: tmpArray });
                        } else {
                            this.setState({ forms: this.state.originList });
                        }
                    }} />
                {
                    this.state.isLoading ? <Spin style={{ width: "100%", marginTop: "60%" }} size="large" /> :
                        <List style={{ marginTop: 45 }}
                            renderFooter={() => (<div style={{ padding: 0, textAlign: 'center' }}>{this.state.isLoading ? '加载中...' : this.state.forms.length > 0 ? '共' + this.state.forms.length + '张表单' : ""}</div>)}>
                            {this.state.forms.length > 0 ? view_listForm : <div className="empty"><div className="img"></div><p className="desc">暂无数据</p></div>}
                        </List>
                }
                {
                    this.state.showFormInfoView ?
                        <div className="formInfo">
                            <div className="maskLayer" style={{ "opacity": this.state.showFormInfoView ? "0.4" : "" }} onClick={this.closeFormInfo}>

                            </div>
                            <div className="information">
                                <div className="popDragIcon"></div>
                                <div className="basicInformation">
                                    <div className="title">{this.state.currentForm.formName}</div>
                                    <div className="group">{this.state.currentForm.groupName}</div>
                                    <div className="basicInfoIcon">
                                        {
                                            this.state.currentForm.isCommon === 1 ? <i className="iconBasicInfo collected" onClick={() => {
                                                this.saveCommonForm(0);
                                            }}></i>
                                                : <i className="iconBasicInfo noCollected" onClick={() => {
                                                    this.saveCommonForm(1);
                                                }}></i>
                                        }
                                        {
                                            // <i className="iconBasicInfo iconMoreDetail"></i>
                                        }
                                    </div>
                                </div>
                                <div className="footer">
                                    <Link to={{ pathname: '/formdatalist', query: { definitionId: this.state.currentForm.definitionId } }}>
                                        <div className="detailData arrow"><i className="icon"></i>明细数据</div>
                                    </Link>
                                    {
                                        // <div className="statistical arrow"><i className="icon"></i>统计报表</div>
                                    }
                                    <div className="addForm" onClick={() => { this.gotoFormMain() }}>发起</div>
                                </div>
                            </div>
                        </div> : ""
                }
            </div>
        )
    }
}

export default withCookies(FormListPage);